<template>
  <div>
    <v-table
    class="v-table-header-line-full"
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorOffboardApplyList.push"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        :clearable="true"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>

    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="员工" width="140">
      <template v-slot="{ row }">
        <v-avatar-nickname
          :value="row.avatar"
          :nickname="row.nickname"
          :avatar-size="28"
          :nickname-overflow="true"
          width="130px"
        />
      </template>
    </el-table-column>
    <el-table-column label="门店" width="160">
      <template v-slot="{ row }">{{ row.store_name | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="类型" width="100">
      <template v-slot="{ row }">{{ leaveTypeName(row.leave_type) }}</template>
    </el-table-column>
    <el-table-column label="原因" prop="leave_reason" width="220" show-overflow-tooltip/>
    <el-table-column label="状态" width="100">
      <template v-slot="{ row }">
        <el-tag :type="applyStateTag(row.apply_state)">{{ applyStateName(row.apply_state) }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="申请时间" width="160">
      <template v-slot="{ row }">{{ row.add_time | timeToYmdHi }}</template>
    </el-table-column>
    <el-table-column label="操作" width="140">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="view" :to="RouteConfig.administratorOffboardApplyDetail.to(row.id)"/>
        <v-list-button v-if="row.apply_state === 2 && row.add_administrator_id === userId" name="撤回" :is-loading="isRevokingIds.includes(row.id)" @click="revoke(row)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`offboard-apply-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>员工</span>
              <span>{{ v.nickname }}</span>
            </div>
            <div class="list-item-detail">
              <span>门店</span>
              <span>{{ v.store_name | formatStoreName }}</span>
            </div>
            <div class="list-item-detail">
              <span>类型</span>
              <span>{{ leaveTypeName(v.leave_type) }}</span>
            </div>
            <div class="list-item-detail">
              <span>原因</span>
              <span>{{ v.leave_reason }}</span>
            </div>
            <div class="list-item-detail">
              <span>状态</span>
              <el-tag :type="applyStateTag(v.apply_state)">{{ applyStateName(v.apply_state) }}</el-tag>
            </div>
            <div class="list-item-button">
              <v-list-button name="查看" icon="view" :to="RouteConfig.administratorOffboardApplyDetail.to(v.id)"/>
              <v-list-button v-if="v.apply_state === 2 && v.add_administrator_id === userId" name="撤回" :is-loading="isRevokingIds.includes(v.id)" @click="revoke(v)"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
  </div>
</template>

<script>
import { applyStates } from '@/enums/applyStates';
import { leaveTypes } from '@/enums/leaveTypes';
import { mapGetters } from 'vuex';
import RouteConfig from '@/router/config';
import { offboardApplyIndex, offboardApplyRevoke } from '@/api/personnel';
import { getLegalQueryList } from '@/utils/formats';
import { removeArrayItem } from '@/utils';

export default {
  name: RouteConfig.administratorOffboardApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    isLoading: false,
    isRevokingIds: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters(['userId']),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.administratorOffboardApplyList.push(this.queryList);
    },
    applyStateName(value) {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(value)) return applyStates[key].name;
      }
      return '';
    },
    applyStateTag(value) {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(value)) return applyStates[key].tagType || 'info';
      }
      return 'info';
    },
    leaveTypeName(value) {
      const item = leaveTypes[Object.keys(leaveTypes).find(key => leaveTypes[key].value === value)] || {};
      return item.name || '';
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await offboardApplyIndex(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list || [];
      if (next) next();
    },
    async revoke(row) {
      if (this.isRevokingIds.includes(row.id)) return;

      this.isRevokingIds.push(row.id);
      const { isError } = await offboardApplyRevoke(row.id);
      removeArrayItem(this.isRevokingIds, row.id);
      if (isError) return;
      this.$message.success('已撤回');
      this.load();
    },
    goDetail(id) {
      RouteConfig.administratorOffboardApplyDetail.push(id);
    },
  },
};
</script>
